import { collection, addDoc, deleteDoc, doc, getDocs, query, orderBy, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function getAgendaRef() {
  return collection(db, ...FS.calendarEvents(appId));
}

export async function loadAgendaEvents() {
  const ref = collection(db, ...FS.calendarEvents(appId));
  const snap = await getDocs(query(ref, orderBy('date', 'asc')));
  return snap.docs.map((d) => ({ id: d.id, ...d.data(), source: 'RDA' }));
}

export async function addAgendaEvent(data) {
  const ref = collection(db, ...FS.calendarEvents(appId));
  return addDoc(ref, { ...data, createdAt: serverTimestamp() });
}

export async function deleteAgendaEvent(id) {
  const ref = doc(db, ...FS.calendarEvents(appId), id);
  return deleteDoc(ref);
}

export async function markAgendaTimesheetSent(id) {
  const ref = doc(db, ...FS.calendarEvents(appId), id);
  return updateDoc(ref, { timesheetSent: true });
}
